import { FormFieldTextArea as ChordsFormFieldTextArea } from '~/chords/FormField';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const FormFieldTextArea = withClassNameHoc(ChordsFormFieldTextArea);
